import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import { FORM } from 'src/constants/Form';
import { useState } from 'react';

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  title: {
    fontWeight: 'bold',
    width: '100px',
  },
}));

const EditVideoDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.editVideoUrl]) {
        return state.dialog[DIALOGS.editVideoUrl];
      }
      return { opened: false, payload: null };
    });

  const { asset, onChange } = payload || {};

  const [url, setUrl] = useState(asset?.video_url || '');
  const [isValidURL, setIsValidURL] = useState(false);

  function TestURL(value: string) {
    const pattern = new RegExp(
      '^([a-zA-Z]+:\\/\\/)?' + // protocol (optional, e.g. http:// or mailto://)
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IPv4 address
      '(\\:\\d+)?' + // optional port
      '(\\/[-a-z\\d%_.~+]*)*' + // path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i',
    );
    return pattern.test(value);
  }

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.editVideoUrl }));
  };

  const handleOk = () => {
    const test = TestURL(url);
    setIsValidURL(test);
    if (onChange && test) {
      onChange({
        ...asset,
        video_url: url,
      });
    }
    dispatch(closeDialog({ dialog: DIALOGS.editVideoUrl }));
  };

  const handleOnChange = (value: Value) => {
    setUrl(value);
  };

  return (
    <Dialog
      aria-labelledby="change-email"
      open={opened}
      maxWidth="sm"
      PaperProps={{
        style: {
          width: '100%',
        },
      }}>
      <DialogTitle id="change-email">Edit Video Url</DialogTitle>
      <DialogContent dividers>
        <div className={classes.row}>
          <span className={classes.title}>New Url:</span>
          <FormTextField
            form={FORM.editVideoUrl}
            label="New url"
            name="url"
            onChange={handleOnChange}
            required
            value={url}
            margin="dense" />
        </div>
        { !isValidURL && (
          <div style={{ fontSize: '12px', color: 'red' }}><i>Invalid URL</i></div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditVideoDialog;
